import "./Disclaimer.css";
import { disclaimer } from "../../../NewConstants/ChatConstants";
import { getUserCadre, getUserKb } from "../../../Actions/Utils";

const Disclaimer = ({ selectedLanguage }) => {
  const DisclaimerText = disclaimer[getUserCadre() + "_" + getUserKb()];
  return (
    <div className='w-[65vw] rounded-md border border-[var(--disclaimer-2)] bg-[var(--disclaimer-3)] p-3'>
      <div className='text-[var(--disclaimer-1)] text-sm font-normal leading-4'>
        <span className='inline-flex items-start justify-center text-center'>
        <img src={"/Assets/Images/lock.svg"} alt='lock'/>
          {DisclaimerText[selectedLanguage]}
        </span>
      </div>
    </div>
  )
}

export default Disclaimer